// extracted by mini-css-extract-plugin
export default {"clientPicker":"ClientBranchPicker_clientPicker__gCp8-","branchPicker":"ClientBranchPicker_branchPicker__KKRlA"};